import { render, staticRenderFns } from "./PieChartTP.vue?vue&type=template&id=36557337&scoped=true&lang=pug&"
import script from "./PieChartTP.vue?vue&type=script&lang=ts&"
export * from "./PieChartTP.vue?vue&type=script&lang=ts&"
import style0 from "./PieChartTP.vue?vue&type=style&index=0&id=36557337&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36557337",
  null
  
)

export default component.exports